document.addEventListener('DOMContentLoaded', function () {
    const menuTitles = document.querySelectorAll('.menu-title');

    function addClickListeners() {
        menuTitles.forEach((title) => {
            title.addEventListener('click', handleMenuClick);
        });
    }

    function removeClickListeners() {
        menuTitles.forEach((title) => {
            title.removeEventListener('click', handleMenuClick);
        });
    }

    function handleMenuClick(event) {
        event.preventDefault();
        const submenu = this.nextElementSibling;

        menuTitles.forEach((otherTitle) => {
            const otherSubmenu = otherTitle.nextElementSibling;

            if (otherTitle !== this) {
                otherSubmenu.classList.add('hidden');
                otherTitle.querySelector('.toggle-icon').textContent = '+';
            }
        });

        submenu.classList.toggle('hidden');

        const icon = this.querySelector('.toggle-icon');
        icon.textContent = submenu.classList.contains('hidden') ? '+' : '−';
    }

    function checkScreenSize() {
        if (window.innerWidth < 768) {
            addClickListeners();
            menuTitles.forEach((title) => {
                const submenu = title.nextElementSibling;
                submenu.classList.add('hidden');
                title.querySelector('.toggle-icon').style.display = 'inline-block';
            });
        } else {
            removeClickListeners();
            menuTitles.forEach((title) => {
                const submenu = title.nextElementSibling;
                submenu.classList.remove('hidden');
                title.querySelector('.toggle-icon').style.display = 'none';
            });
        }
    }

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
});
